/**
 *
 * TimeWindowCheckBox
 *
 */

import { PureComponent } from "react";
import * as PropTypes from "prop-types";
import styled from "styled-components";
import RadioButton from "basicComponents/RadioButton/RadioButton";
import FormattedDate from "basicComponents/FormattedDate/Formatted";
import { FormattedMessage } from "react-intl";
import { DATE_FORMATS, roundMinutes } from "utils/Date";
import moment from "moment";
import messages from "./messages";

export const MINUTE_MULTIPLIER = 5;

class TimeWindowCheckBox extends PureComponent {
  static propTypes = {
    locale: PropTypes.string.isRequired,
    time: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
  };

  handleChecked = () => {
    this.props.onClick(this.props.time.timewindow);

    this.setState(prevState => ({ checked: !prevState.checked }));
  };

  state = {
    checked: false,
  };

  render() {
    const { timewindow } = this.props.time;

    const fromDate = roundMinutes(
      moment(timewindow.proposed_plan_date_time_from, DATE_FORMATS.BUMBAL),
      MINUTE_MULTIPLIER,
    );
    const toDate = roundMinutes(
      moment(timewindow.proposed_plan_date_time_to, DATE_FORMATS.BUMBAL),
      MINUTE_MULTIPLIER,
    );

    //  id={fromDate._i.replace(/\s/g, "-")} for selenium test in the future. to grab checkbox id/

    return (
      <Wrapper>
        <TextPadding>
          <RadioButton
            id={fromDate.format("HHmm")}
            name="select"
            defaultChecked={this.state.checked}
            onChange={this.handleChecked}
          />
          <FormattedMessage {...messages.from} />
          <SpanBold>
            <FormattedDate
              date={fromDate}
              format={DATE_FORMATS.HUMAN_READABLE_TIME}
            />
          </SpanBold>
          <FormattedMessage {...messages.to} />
          <SpanBold>
            <FormattedDate
              date={toDate}
              format={DATE_FORMATS.HUMAN_READABLE_TIME}
            />
          </SpanBold>
          {timewindow.proposed_driver && (
            <SpanBold>
              {"( ".concat(
                timewindow.proposed_driver.first_name,
                " ",
                timewindow.proposed_driver.last_name,
                " )",
              )}
            </SpanBold>
          )}
        </TextPadding>
      </Wrapper>
    );
  }
}

const SpanBold = styled.span`
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

const TextPadding = styled.div`
  * {
    margin-right: 5px;
  }
`;

export default TimeWindowCheckBox;
